import { render, staticRenderFns } from "./TabBar.vue?vue&type=template&id=1f866a81&scoped=true&"
import script from "./TabBar.vue?vue&type=script&lang=ts&"
export * from "./TabBar.vue?vue&type=script&lang=ts&"
import style0 from "./TabBar.vue?vue&type=style&index=0&id=1f866a81&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f866a81",
  null
  
)

export default component.exports